import { type Camera, type Vector2, Vector3 } from 'three';

export function formatDistance(distance: number, unit: string | null): string {
  if (unit === 'mm') {
    if (distance >= 1000) return `${distance.toFixed(0)} mm (${(distance / 1000).toFixed(2)} m)`;
    return `${distance.toFixed(1)} mm`;
  }
  if (unit === 'm') {
    if (distance < 1) return `${(distance * 1000).toFixed(0)} mm`;
    return `${distance.toFixed(2)} m`;
  }
  if (unit) return `${distance.toFixed(2)} ${unit}`;
  return distance.toFixed(2);
}

/**
 * Snap a raycast hit to the nearest candidate vertex whose screen-space
 * distance to the pointer is within `thresholdPx`; falls back to the raw hit.
 */
export function snapToVertex(
  hit: Vector3,
  vertices: Vector3[],
  camera: Camera,
  pointerPx: Vector2,
  canvas: { width: number; height: number },
  thresholdPx: number,
): Vector3 {
  let best: Vector3 | null = null;
  let bestDist = thresholdPx;
  const projected = new Vector3();
  for (const vertex of vertices) {
    projected.copy(vertex).project(camera);
    const px = ((projected.x + 1) / 2) * canvas.width;
    const py = ((1 - projected.y) / 2) * canvas.height;
    const dist = Math.hypot(px - pointerPx.x, py - pointerPx.y);
    if (dist <= bestDist) {
      bestDist = dist;
      best = vertex;
    }
  }
  return best ?? hit;
}
